import { MACBOOK_AIR_MAX_WIDTH } from 'constants/styles';

export const isWidePC = () => window.innerWidth <= MACBOOK_AIR_MAX_WIDTH;
